import React, { FC } from 'react';
import { IonPage, useIonViewWillEnter } from '@ionic/react';
import { RouteComponentProps } from 'react-router-dom';
import { AppHeader_v2 as AppHeader, IconArrowLeft, IconButton } from '@mindly/ui-components';
import { useAuthFlow } from '../../shared';
import { PrivateRoutes, PublicRoutes } from '../../routes/navigation';
import { ProfileLastNameWidget } from '../../widgets';

const NeedUpdatePersonalDataLastNamePage: FC<RouteComponentProps> = ({ history }) => {
  const { authUser } = useAuthFlow();

  useIonViewWillEnter(() => {
    if (!authUser) {
      history.push(PublicRoutes.AUTH);
      return;
    }
  }, []);

  return (
    <IonPage>
      <AppHeader className="flex flex-row items-start mb-4 cursor-pointer">
        <IconButton
          icon={<IconArrowLeft />}
          onClick={() => history.push(PrivateRoutes.NEED_UPDATE_PERSONAL_DATA_FIRST_NAME)}
        />
      </AppHeader>
      <ProfileLastNameWidget
        onSuccess={() => {
          history.push(PrivateRoutes.NEED_UPDATE_PERSONAL_DATA_DOB);
        }}
      />
    </IonPage>
  );
};

export default NeedUpdatePersonalDataLastNamePage;
